import icon from './svg/Mock';
import { createIconComp } from './Core/createIconComp';

export const MockIcon = createIconComp({ icon });
